<template id="print">
  <div class="mainDiv">
    <el-row>
      <el-col :offset="6">
        <el-button type="primary" @click="doPrint">点击打印</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:150px">
      <el-col >

        <div id="printDiv" v-html="htmlData"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "print",
  data() {
    return {
      htmlData: ""
    };
  },
  created: function () {
    this.$root.eventHub.$on(this.GLOBAL.PRINT_FLOW, this.initHtml);
  },
  destroyed: function () {
    this.$root.eventHub.$off(this.GLOBAL.PRINT_FLOW);
  },
  mounted: function() {
    // this.initHtml()
  },
  methods: {
    initHtml(data){
      this.htmlData = data;
    },
    doPrint(){
          //Print ele4 with custom options
          $("#printDiv").print({
              //Use Global styles
              globalStyles : false,
              //Add link with attrbute media=print
              mediaPrint : false,
              //Print in a hidden iframe
              iframe : false,
              //Don't print this
              noPrintSelector : ".avoid-this",
              // //Add this at top
              // prepend : "Hello World!!!<br/>",
              // //Add this on bottom
              // append : "<br/>Buh Bye!",
              //Log to console when printing is done via a deffered callback
              deferred: $.Deferred().done(function() { 
                // console.log('Printing done', arguments); 
              })
          });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/deep/  .el-upload {
    display: none;
    text-align: center;
    cursor: pointer;
    outline: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/print.vue